<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >{{hdrText}}  ГОСТ </v-toolbar>
      <ref-g-o-s-t2-ft-card :mode="'editor'" :g-o-s-t="localGOST" @onGOSTUpdate="doGOSTUpdate"></ref-g-o-s-t2-ft-card>
      <v-card-actions>
        <v-btn class="secondary" @click="doClose">
          Отмена
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark outlined :disabled="saveDisabled" @click="doSave">
          {{btnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'
import RefGOST2FtCard from '@/components/modules/references/cards/refGOST2FTCard'

export default {
  name: 'refAddGOST2FTDialog',
  components: { RefGOST2FtCard },
  props: ['gost', 'value'],
  data () {
    return {
      localGOST: {}
    }
  },
  computed: {
    btnText: {
      get () {
        return this.localGOST ? this.localGOST.GOST_ID ? 'Сохранить' : 'Создать' : 'Создать'
      }
    },
    hdrText: {
      get () {
        return this.localGOST ? this.dataNew ? 'Добавление' : 'Редактирование' : 'Добавление'
      }
    },
    dataNew: {
      get: function () {
        return !this.localGOST.GOST_ID
      }
    },
    dataChanged: {
      get () {
        if (!this.gost) return false
        if (this.dataNew) return true
        return this.gost.GOST_CODE !== this.localGOST.GOST_CODE || !this.localGOST.FT || !this.localGOST.FT.FT_ID
      }
    },
    saveDisabled: {
      get: function () {
        if (!this.localGOST) return true
        const noName = !this.localGOST.GOST_NAME
        const noCode = !this.localGOST.GOST_CODE
        const noFT = !this.localGOST.FT || !this.localGOST.FT.FT_ID
        console.log('refAddGOST2FTDialog returning saveDisabled value. Flags: noName ', noName, 'noCode: ', noCode, 'noFT: ', noFT, ' dataChanged: ', this.dataChanged)
        return noName || noCode || noFT || !this.dataChanged
      }
    }
  },
  watch: {
    gost (val) {
      if (val) {
        // eslint-disable-next-line no-undef
        this.localGOST = structuredClone(this.gost)
      } else {
        this.localGOST = {}
      }
    }
  },
  methods: {
    doSave () {
      const self = this
      const action = this.localGOST.GOST_ID ? 'update' : 'add'
      const processorPath = action === 'update' ? '/api/org/references/updGOST2FT.php' : '/api/org/references/addGOST2FT.php'
      const payload = { ...this.localGOST }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              self.$emit('gostAdded', [resp.data.data])
            } else {
              self.$emit('gostUpdate', [resp.data.data])
            }
            self.$emit('input', false)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doGOSTUpdate (data) {
      console.log('refAddGOST2FTDialog:: doPropUpdate method called ', data)
      this.localGOST = { ...this.localGOST, ...data }
      console.log('refAddGOST2FTDialog:: doPropUpdate current data is ', this.localGOST)
    }
  },
  mounted () {
    console.log('refAddGOST2FTDialog mounted with GOST ', this.gost, ' Data changed flag is ', this.dataChanged)
  }
}
</script>
